<template>
  <div :class="['stats-timeline', { 'sidebar-hidden': !isSidebarVisible }]">
    <LiveMap
      :isSidebarVisible="isSidebarVisible"
      :gatewayTimelinePosition="gatewayTimelinePosition"
      :timelineSegmentPoints="timelineSegmentPoints"
    />
    <el-button
      class="dashboard-toggle"
      @click="isSidebarVisible = !isSidebarVisible"
      style="text-transform: none;"
      v-if="!isSidebarVisible"
    >
      {{ $t("analytics.timeline") }}
      <i class="el-icon-right"></i>
    </el-button>
    <div class="sidebar" v-if="isSidebarVisible">
      <div class="sidebar__header">
        <h3 class="header-title">
          <template v-if="clientData.type === 0">
            {{ $t("statsTimeline.titleVehicle") }}
          </template>
          <template v-else>
            {{ $t("statsTimeline.titleGateway") }}
          </template>
        </h3>
        <div
          class="sidebar-toggle"
          @click="isSidebarVisible = !isSidebarVisible"
          style="text-transform: none;"
        >
          <template>
            <i class="el-icon-close"></i>
          </template>
        </div>
      </div>
      <div class="sidebar__content">
        <TimelineSidebarContent
          @update-gateway-position="val => (gatewayTimelinePosition = val)"
          @update-segments="val => (timelineSegmentPoints = val)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LiveMap from "@/views/LiveMap.vue";
import { mapState } from "vuex";
import TimelineSidebarContent from "@/components/stats/TimelineSidebarContent.vue";

export default {
  name: "StatsTimeline",
  components: {
    LiveMap,
    TimelineSidebarContent
  },
  data() {
    return {
      isSidebarVisible: true,
      gatewayTimelinePosition: {},
      timelineSegmentPoints: []
    };
  },
  computed: {
    ...mapState("user", {
      resources: "resources"
    }),
    ...mapState("clients", {
      clientData: "data"
    })
  }
};
</script>

<style lang="scss">
.stats-timeline {
  position: relative;
  display: flex;
  height: calc(100vh - 60px);

  &.sidebar-hidden {
    .dashboard {
      width: 100vw;
    }
  }
  .dashboard-toggle {
    position: fixed;
    top: 78px;
    right: 10px;
    padding: 8px 12px;
    font-size: 14px;
    border-radius: 8px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65) !important;
    cursor: pointer;
    font-weight: bold;
    z-index: 1000;
  }
  .sidebar-toggle {
    font-size: 14px;
    cursor: pointer;
    font-weight: bold;

    &:hover {
      color: #606266;
    }
  }
  .sidebar {
    background: #ffffff;
    width: 700px;
    height: 100%;
    border-left: 1px solid $--border-color-base;
    display: flex;
    flex-direction: column;

    @media (max-width: 800px) {
      position: absolute;
      padding-left: 5px;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 40;
      width: 100%;
    }

    &__header {
      padding: 24px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #e2e4e9;
    }
    &__content {
      padding: 24px;
      flex: 1 1 0%;
      overflow-y: auto;
    }
  }
  .dashboard__map-wrapper {
    height: calc(100vh - 60px);
  }
  .dashboard {
    padding-top: 0;
    width: 100%;
    height: 100%;
    flex-grow: 1;
  }
  .dashboard__map.leaflet-container {
    height: calc(100vh - 60px);
    border-bottom: none;
  }
}
</style>
